import { render, staticRenderFns } from "./FireHasRealEstateDamagesQuestion.vue?vue&type=template&id=6d10bd4f&scoped=true"
import script from "./FireHasRealEstateDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./FireHasRealEstateDamagesQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10bd4f",
  null
  
)

export default component.exports